var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6016 11.334C20.229 11.334 25.6016 9.09541 25.6016 6.33398C25.6016 3.57256 20.229 1.33398 13.6016 1.33398C6.97421 1.33398 1.60162 3.57256 1.60162 6.33398C1.60162 9.09541 6.97421 11.334 13.6016 11.334Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6016 11.709C25.6016 14.4702 20.2266 16.709 13.6016 16.709C6.97662 16.709 1.60162 14.4702 1.60162 11.709",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6016 17.084C25.6016 19.8452 20.2266 22.084 13.6016 22.084C6.97662 22.084 1.60162 19.8452 1.60162 17.084",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.60162 6.28711V22.3821C1.60162 25.1171 6.97662 27.3346 13.6016 27.3346C20.2266 27.3346 25.6016 25.1171 25.6016 22.3821V6.28711",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.c1fcca1e9692f5d6b77b973e12b534a9.svg";
export { ForwardRef as ReactComponent };